import * as legacy from './legacy';
import * as effects from './src';

export default { ...legacy, ...effects };
